import React from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import { getLegalDocument, LEGAL_DOCUMENTS } from '../content/legalDocuments';
import LegalDocumentContent from '../components/LegalDocumentContent';
import { useLanguage } from '../hooks/useLanguage';

export default function LegalPage() {
  const { documentKey } = useParams();
  const { t } = useLanguage();
  const legalDocument = getLegalDocument(documentKey);

  if (!legalDocument) return <Navigate to="/legal/privacy" replace />;

  return (
    <main className="legal-page page-width">
      <header className="legal-page__header">
        <p className="section-kicker">{t('legal.title')}</p>
        <h1 lang="ru">{legalDocument.title}</h1>
        <p lang="ru">{legalDocument.description}</p>
      </header>
      <nav className="legal-page__nav" aria-label={t('legal.title')}>
        {Object.entries(LEGAL_DOCUMENTS).map(([key, item]) => (
          <Link key={key} to={`/legal/${key}`} aria-current={key === documentKey ? 'page' : undefined}>
            {t(`footer.${key}`, item.shortTitle)}
          </Link>
        ))}
      </nav>
      <LegalDocumentContent legalDocument={legalDocument} headingLevel="h2" />
    </main>
  );
}
